import React from 'react';

// Import logos
import logo1 from '../assets/LOGOS/1.webp';
import logo2 from '../assets/LOGOS/2.webp';
import logo3 from '../assets/LOGOS/3.webp';
import logo4 from '../assets/LOGOS/4.webp';

const DespreProiect = () => {
  return (
    <>
      <main className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header Section */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold gradient-text mb-6 font-display">
              Proiect Digitalizare
            </h1>
            <div className="w-32 h-1 bg-gradient-to-r from-navy-600 via-gold-500 to-emerald-600 mx-auto rounded-full"></div>
          </div>

          {/* Logos Section */}
          <div className="mb-16">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
              <div className="flex justify-center items-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <img src={logo1} alt="Logo 1" className="max-w-full h-auto max-h-20 object-contain" />
              </div>
              <div className="flex justify-center items-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <img src={logo2} alt="Logo 2" className="max-w-full h-auto max-h-20 object-contain" />
              </div>
              <div className="flex justify-center items-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <img src={logo3} alt="Logo 3" className="max-w-full h-auto max-h-20 object-contain" />
              </div>
              <div className="flex justify-center items-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <img src={logo4} alt="Logo 4" className="max-w-full h-auto max-h-20 object-contain" />
              </div>
            </div>
          </div>

          {/* Project Information */}
          <div className="max-w-4xl mx-auto">
            <div className="space-y-12">
              
              {/* Titlul proiectului */}
              <div className="bg-gradient-to-r from-cream-50 to-gold-50 rounded-2xl p-8 shadow-lg border border-gold-100">
                <h2 className="text-2xl font-bold text-navy-800 mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gradient-to-b from-navy-600 to-gold-600 rounded-full mr-4"></span>
                  Titlul proiectului:
                </h2>
                <p className="text-xl font-semibold text-navy-700 pl-6">
                  DIGITALIZARE
                </p>
              </div>

              {/* Denumirea beneficiarului */}
              <div className="bg-gradient-to-r from-navy-50 to-emerald-50 rounded-2xl p-8 shadow-lg border border-navy-100">
                <h2 className="text-2xl font-bold text-navy-800 mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gradient-to-b from-emerald-600 to-navy-600 rounded-full mr-4"></span>
                  Denumirea beneficiarului:
                </h2>
                <p className="text-xl font-semibold text-navy-700 pl-6">
                  BOTEZ DE POVESTE SRL
                </p>
              </div>

              {/* Scopul proiectului */}
              <div className="bg-gradient-to-r from-emerald-50 to-cream-50 rounded-2xl p-8 shadow-lg border border-emerald-100">
                <h2 className="text-2xl font-bold text-navy-800 mb-6 flex items-center">
                  <span className="w-2 h-8 bg-gradient-to-b from-gold-600 to-emerald-600 rounded-full mr-4"></span>
                  Scopul proiectului:
                </h2>
                <div className="pl-6 space-y-4 text-gray-700 leading-relaxed">
                  <p>
                    Proiectul contribuie la realizarea obiectivului specific al apelului <span className="font-semibold text-navy-700">RSO1.2 – FEDR – RSO1.2_Valorificarea avantajelor digitalizării</span>, în beneficiul cetățenilor, al companiilor, al organizațiilor de cercetare și al autorităților publice, întrucât prin realizarea investiției propuse de către beneficiar, acesta urmărește digitalizarea societății comerciale.
                  </p>
                  <p>
                    Prin intermediul acestui proiect, ne propunem să consolidăm infrastructura IT existentă, să implementăm soluții digitale de ultimă generație și să creăm un ecosistem robust care să faciliteze o mai bună colaborare între diferitele entități economice și instituții.
                  </p>
                </div>
              </div>

              {/* Rezultate */}
              <div className="bg-gradient-to-r from-gold-50 to-navy-50 rounded-2xl p-8 shadow-lg border border-gold-100">
                <h2 className="text-2xl font-bold text-navy-800 mb-6 flex items-center">
                  <span className="w-2 h-8 bg-gradient-to-b from-navy-600 to-gold-600 rounded-full mr-4"></span>
                  Rezultate:
                </h2>
                <div className="pl-6 grid md:grid-cols-2 gap-6">
                  <div className="bg-white/70 rounded-xl p-6 shadow-md border border-gold-200">
                    <h3 className="font-bold text-navy-700 mb-3">Digitalizarea companiei</h3>
                    <p className="text-gray-700">prin achiziția de echipamente IT</p>
                  </div>
                  <div className="bg-white/70 rounded-xl p-6 shadow-md border border-navy-200">
                    <h3 className="font-bold text-navy-700 mb-3">Digitalizarea proceselor</h3>
                    <p className="text-gray-700">operaționale prin software personalizat</p>
                  </div>
                </div>
              </div>

              {/* Date și Perioade */}
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-gradient-to-br from-cream-50 to-gold-50 rounded-2xl p-8 shadow-lg border border-cream-200">
                  <h2 className="text-xl font-bold text-navy-800 mb-4 flex items-center">
                    <span className="w-2 h-6 bg-gradient-to-b from-emerald-600 to-gold-600 rounded-full mr-3"></span>
                    Data de începere:
                  </h2>
                  <p className="text-lg font-semibold text-navy-700 pl-5">13.09.2024</p>
                </div>

                <div className="bg-gradient-to-br from-navy-50 to-emerald-50 rounded-2xl p-8 shadow-lg border border-navy-200">
                  <h2 className="text-xl font-bold text-navy-800 mb-4 flex items-center">
                    <span className="w-2 h-6 bg-gradient-to-b from-gold-600 to-navy-600 rounded-full mr-3"></span>
                    Perioada de implementare:
                  </h2>
                  <p className="text-lg font-semibold text-navy-700 pl-5">13.09.2024 - 12.09.2025</p>
                </div>
              </div>

              {/* Informații Financiare */}
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-gradient-to-br from-gold-50 to-emerald-50 rounded-2xl p-8 shadow-lg border border-gold-200">
                  <h2 className="text-xl font-bold text-navy-800 mb-4 flex items-center">
                    <span className="w-2 h-6 bg-gradient-to-b from-navy-600 to-emerald-600 rounded-full mr-3"></span>
                    Valoarea totală a proiectului:
                  </h2>
                  <p className="text-2xl font-bold text-emerald-600 pl-5">547.000,00 lei</p>
                </div>

                <div className="bg-gradient-to-br from-emerald-50 to-navy-50 rounded-2xl p-8 shadow-lg border border-emerald-200">
                  <h2 className="text-xl font-bold text-navy-800 mb-4 flex items-center">
                    <span className="w-2 h-6 bg-gradient-to-b from-gold-600 to-emerald-600 rounded-full mr-3"></span>
                    Sprijinul financiar UE:
                  </h2>
                  <p className="text-xl font-bold text-navy-700 pl-5 mb-2">418.455,00 lei</p>
                  <p className="text-sm text-gray-600 pl-5">(FEDR/FSE+/FC/FTJ)</p>
                </div>
              </div>

              {/* Footer Message */}
              <div className="text-center bg-gradient-to-r from-navy-50 via-cream-50 to-gold-50 rounded-2xl p-8 mt-16 border border-navy-100">
                <p className="text-lg text-gray-700 italic">
                  Acest proiect este cofinanțat din Fondul European de Dezvoltare Regională prin 
                  <span className="font-semibold text-navy-700"> Programul Regional Nord-Est 2021-2027</span>
                </p>
              </div>

              {/* Additional Information Section */}
              <div className="text-center bg-gradient-to-r from-emerald-50 via-gold-50 to-navy-50 rounded-2xl p-8 mt-8 border border-emerald-200">
                <h3 className="text-xl font-bold text-navy-800 mb-6 flex items-center justify-center">
                  <span className="w-2 h-6 bg-gradient-to-b from-emerald-600 to-navy-600 rounded-full mr-3"></span>
                  Informații suplimentare
                </h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Pentru informații detaliate despre celelalte programe cofinanțate de Uniunea Europeană, vă invităm să vizitați:
                </p>
                
                <div className="grid md:grid-cols-3 gap-6">
                  {/* MFE Link */}
                  <div className="bg-white/70 rounded-xl p-6 shadow-md border border-navy-200 hover:shadow-lg transition-all duration-300 group">
                    <div className="flex items-center justify-center mb-4">
                      <div className="w-12 h-12 bg-gradient-to-r from-navy-600 to-navy-700 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <span className="text-white font-bold text-lg">MFE</span>
                      </div>
                    </div>
                    <a 
                      href="https://mfe.gov.ro" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="block text-navy-700 hover:text-navy-900 font-semibold transition-colors duration-300"
                    >
                      mfe.gov.ro
                    </a>
                    <p className="text-sm text-gray-600 mt-2">Ministerul Fondurilor Europene</p>
                  </div>

                  {/* Regio Nord-Est Link */}
                  <div className="bg-white/70 rounded-xl p-6 shadow-md border border-gold-200 hover:shadow-lg transition-all duration-300 group">
                    <div className="flex items-center justify-center mb-4">
                      <div className="w-12 h-12 bg-gradient-to-r from-gold-500 to-gold-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <span className="text-white font-bold text-sm">RNE</span>
                      </div>
                    </div>
                    <a 
                      href="https://www.regio-nordest.ro" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="block text-gold-700 hover:text-gold-900 font-semibold transition-colors duration-300"
                    >
                      www.regio-nordest.ro
                    </a>
                    <p className="text-sm text-gray-600 mt-2">Programul Regional Nord-Est</p>
                  </div>

                  {/* Facebook Link */}
                  <div className="bg-white/70 rounded-xl p-6 shadow-md border border-emerald-200 hover:shadow-lg transition-all duration-300 group">
                    <div className="flex items-center justify-center mb-4">
                      <div className="w-12 h-12 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                        </svg>
                      </div>
                    </div>
                    <a 
                      href="https://www.facebook.com/Regio.NordEst.ro" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="block text-emerald-700 hover:text-emerald-900 font-semibold transition-colors duration-300"
                    >
                      facebook.com/Regio.NordEst.ro
                    </a>
                    <p className="text-sm text-gray-600 mt-2">Pagina oficială Facebook</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </main>

      {/* Decorative Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        {/* Ambient Particles */}
        {[...Array(8)].map((_, i) => (
          <div
            key={`project-particle-${i}`}
            className={`absolute rounded-full opacity-10 ${
              i % 3 === 0 ? 'w-1 h-1 bg-navy-400' : 
              i % 3 === 1 ? 'w-1.5 h-1.5 bg-gold-400' : 
              'w-0.5 h-0.5 bg-emerald-400'
            } ${i % 2 === 0 ? 'particle-1' : 'particle-2'}`}
            style={{
              left: `${10 + Math.random() * 80}%`,
              top: `${10 + Math.random() * 80}%`,
              animationDelay: `${Math.random() * 15}s`,
              animationDuration: `${25 + Math.random() * 10}s`
            }}
          />
        ))}
      </div>
    </>
  );
};

export default DespreProiect;
